import { css } from '@emotion/react'

export const styles = () => ({
  posts: {
    main: css``,
  },
})
